import { mapGetters } from "vuex";
import {
  fetchFooterFieldOption,
  fetchFooterFieldTypes,
  saveFooterFields,
  getPrivacyStatementConfig,
  putPrivacyStatementConfig
} from "../services";

// TODO: Rework footer model to make it same as privacyStatement
export default {
  computed: {
    ...mapGetters(['getTenantId', 'getClientId', 'getIsClient']),

    singleSelectConfig() {
      return {
        searchable: true,
        config: { label: 'field_label', trackBy: 'field_id' },
        maxWidth: '100%',
        minWidth: '100%',
        colors: {
          text: '#282828',
          bg: 'white',
          svg: '#282828',
          border: '#bcbcbc',
        },
        disabled: !this.privacyStatement.active,
        options: this.footerFieldOption,
      };
    },

    multiselectConfig() {
      return {
        type: "multi-select",
        multiple: true,
        variant: "alt",
        max: 5,
        noAllControls: true,
        config: { label: 'field_label', trackBy: 'field_id' },
        searchable: true,
        allowEmpty: true,
        options: this.footerFieldOption,
        disabled: !this.usePrivacyPolicy,
      };
    },

    textFieldStyles() {
      return {
        width: "calc(100% - 2rem)",
        height: "calc(100% - 2rem)"
      }
    },

    isFooterFieldLimitReached() {
      return Array.isArray(this.footerField) && this.footerField.length >= 5;
    },

    clientId() {
      return this.$route.params.clientId ?? this.getClientId;
    },
  },

  watch: {
    privacyPolicyText(newVal, oldVal) {
      if(newVal !== oldVal) { 
        this.errorInPrivacyPolicy = "";
      }
    },
    "privacyStatement.text"(newVal, oldVal) {
      console.log(newVal, oldVal)
      if(newVal !== oldVal) {
        this.privacyStatement.error = "";
      }
    }
  },

  methods: {
    async setFooterDetails() {
      const { field_types } = await fetchFooterFieldTypes();
      const field_type = field_types.find((type) => type.name === "label info rich text")?.id;
      
      const id = this.getIsClient ? this.getClientId : this.getTenantId;
      const { fields } = await fetchFooterFieldOption(id, field_type);
      this.footerFieldOption = fields?.map((f) => ({ field_label: f?.name, field_id: f?.id})) ?? [];
    },

    async fetchPrivacyStatement(config = {}) {
      const { userType, id } = this.defineUserType(config);

      const data = await getPrivacyStatementConfig(userType, id);
      const { field_id, text_content, active } = data ?? {};
      this.privacyStatement.active = active ?? false;
      this.privacyStatement.field = this.footerFieldOption?.find(f => f?.field_id === field_id) ??  null;
      this.privacyStatement.text = text_content ?? "";

      this.$nextTick(() => {
        if (this.$refs.privacyStatementTextarea && text_content) {
          this.$refs.privacyStatementTextarea.innerHTML = text_content;
        }
      });

      return text_content;
    },

    async updateFooterDetails(config = {}) {
      const { useClient } = config ?? {};

      const subjectId = this.getIsClient ? this.getClientId : this.getTenantId;
      const payload = {
        use_footer: this.usePrivacyPolicy,
        subject_type: useClient ? 'client' : 'tenant',
        subject_id: useClient ? this.clientId : subjectId,
        field_id: this.footerField?.length ? this.footerField.map(f => f.field_id) : [],
        text_area: this.privacyPolicyText
      }

      try {
        const response = await saveFooterFields(payload);
        if(response.status === 200 ){
          this.$toast.success("Footer fields saved successfully.")
        }
      } catch (e) {
        this.$toast.error(this.$t('pages.theme_admin.failed_to_save'));
      }
    },

    async savePrivacyStatement(config = {}) {
      const { userType, id } = this.defineUserType(config);

      try {
        await putPrivacyStatementConfig(userType, id, {
          field_id: this.privacyStatement.field?.field_id ?? null,
          text_content: this.privacyStatement.text,
          active: this.privacyStatement.active,
        });
      } catch(e) {
        this.$toast.error(this.$t('pages.theme_admin.failed_to_save'));
      }
    },

    defineUserType(config = {}) {
      const { useClient } = config ?? {};
      const userType = useClient ? 'client' : 'tenant';
      return { userType, id: useClient ? this.clientId : this.getTenantId };
    },

    handlePaste(event, target) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text').trim();
      const selection = window.getSelection();
      const selectedText = selection.toString().trim();
      const urlRegex = /^https?:\/\/[^\s<]+$/;
      
      if (selectedText && urlRegex.test(pastedText)) {
        // Create hyperlink with visual styling
        const range = selection.getRangeAt(0);
        const link = document.createElement('a');
        link.href = pastedText;
        link.target = '_blank';
        link.className = 'text-primary underline cursor-pointer';
        link.textContent = selectedText;
        
        range.deleteContents();
        range.insertNode(link);
        selection.removeAllRanges();

        if (target === "footer") {
          this.privacyPolicyText = this.$refs.footerTextarea.innerHTML;
        }

        if (target === 'privacyStatement') {
          this.privacyStatement.text = this.$refs.privacyStatementTextarea.innerHTML;
        }
      } else {
        document.execCommand('insertText', false, pastedText);
      }
    },

    handleInput(event, target) {
      const content = event.target.innerHTML;
      console.log("content", content)
      // Clean empty content - if only contains <br> or whitespace, set to empty string
      if (content === '<br>' || content.trim() === '' || content === '<div><br></div>') {
        // this.privacyPolicyText = '';

        if (target === 'privacyStatement') {
          this.privacyStatement.text = ""
        }

        if (target === 'footer') {
          this.privacyPolicyText = "";
        }
        event.target.innerHTML = '';
      } else {
        if (target === 'privacyStatement') {
          this.privacyStatement.text = content;
        }

        if (target === 'footer') {
          this.privacyPolicyText = content;
        }
      }
    },

    validateTextArea(target) {
      const value = target === 'footer'
        ? this.privacyPolicyText
        : this.privacyStatement.text;

      // Get visible text only (strip HTML tags)
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = value;
      const visibleText = tempDiv.textContent || tempDiv.innerText || '';

      // 1. Max 200 characters (visible text only)
      if (visibleText.length > 200) {
        if (target === 'footer') {
          this.errorInPrivacyPolicy = 'footer_text_must_not_exceed_200_characters';
        }
        if (target === 'privacyStatement') {
          this.privacyStatement.error = 'privacy_policy_text_must_not_exceed_200_characters';
        }
        return;
      }

      // 2. Allow only HTTP/HTTPS valid links
      let isAllValid = this.hasOnlyValidUrls(value);
      if (!isAllValid) {
        if (target === 'footer') {
          this.errorInPrivacyPolicy = 'only_valid_HTTP_HTTPS_links_are_allowed';
        }
        if (target === 'privacyStatement') {
          this.privacyStatement.error = 'only_valid_HTTP_HTTPS_links_are_allowed';
        }
        return;
      }

      // 3. Support UTF-8 (automatically supported in modern browsers)
      if (target === 'footer') {
        this.errorInPrivacyPolicy = ''; // No error
      }

      if (target === 'privacyStatement') {
        this.privacyStatement.error = ''; // No error
      }
    },

    cleanTextArea() {
      // Clean the content before processing
      if (this.privacyPolicyText === '<br>' || this.privacyPolicyText.trim() === '' || this.privacyPolicyText === '<div><br></div>') {
        this.privacyPolicyText = '';
      }

      if (this.privacyStatement.text === '<br>' || this.privacyStatement.text.trim() === '' || this.privacyStatement.text === '<div><br></div>') {
        this.privacyStatement.text = '';
      }
    },

    // Utils
    hasOnlyValidUrls(text) {
      const urls = this.extractUrls(text);
      return urls.every(this.isValidHttpUrl);
    },

    // Utils
    extractUrls(text) {
      const urlRegex = /(https?:\/\/[^\s<]+)/g;
      return [...text.matchAll(urlRegex)].map(match => match[0]);
    },

    // Utils
    isValidHttpUrl(url) {
      try {
        const parsed = new URL(url);
        return parsed.protocol === "http:" || parsed.protocol === "https:" && !parsed.hostname.includes('..');
      } catch (e) {
        return false; // Invalid URL format
      }
    },
  }
}
